import React, {FC, useState} from "react";
import AppUtil from "../../../util/AppUtil";
import AppConstants from "../../../util/AppConstants";
import {useSub} from "../../../service/TickManager";
import {INFINITY} from "chart.js/helpers";
import {ComboAnalysePopup} from "./ComboAnalysePopup";
import GatewayService from "../../../service/GatewayService";
import {DeepCombo} from "../../../models/DeepCombo";
import {Combo} from "../../../models/Combo";

interface Props {
    func : (func:(a:any, b:any)=>number)=>void
}



export const DeepHead : FC<Props> = (props) => {
    return<thead>
    <tr>
        <th>type</th>
        <th>sellOption</th>
        <th>sellOptionAt</th>
        <th>Fut</th>
        <th>buyFut</th>
        <th>sellFut</th>
        <th onClick={()=>props.func(AppUtil.genericSorter("maxProfit"))}>maxProfit</th>
        <th onClick={()=>props.func(AppUtil.genericSorter("netMax"))}>netMax</th>
        <th>taxes</th>
        <th onClick={()=>props.func(AppUtil.genericSorter("percentFut"))}>percentFut</th>
        <th onClick={()=>props.func(AppUtil.genericSorter("depthPercent"))}>depthPercent</th>
    </tr>
    </thead>
}

function exec(combo: Combo) {
    GatewayService.exec(combo)
}

export const DeepCombosComp : FC<DeepCombo> = (row) => {
    const [flag, refresh] = useState(false)
    let option = (row.sellCall||row.sellPut)!;
    return <>
    <tr>
        <td>{row.type}</td>
        <td>{option.genInfo.tradingsymbol}-{option.miniTick.lastPrice}</td>
        <td>{AppUtil.maxBuyer((row.sellCall||row.sellPut)!)}</td>
        <td>{(row.buyFut||row.sellFut)!.genInfo.tradingsymbol}</td>
        <td>{row.buyFut?AppUtil.minSeller(row.buyFut):""}</td>
        <td>{row.sellFut?AppUtil.maxBuyer(row.sellFut):""}</td>
        <td>{row.maxProfit.toFixed(2)}</td>
        <td>{(row.netMax).toFixed(2)}</td>
        <td>{row.brokerageIncludingSqOff.toFixed(2)}</td>
        <td>{(row.percentFut).toFixed(2)}</td>
        <td>{row.depthPercent.toFixed(2)}</td>
    </tr>
    </>
}




